import { createContext, useContext } from "react";
import type { Org, OrgMember } from "@rivets/core";

export interface OrgContextValue {
  orgId: string;
  org?: Org;
  members: OrgMember[];
  role?: "owner" | "member";
  membersById: Map<string, OrgMember>;
}

export const OrgContext = createContext<OrgContextValue | null>(null);

export function useOrgContext(): OrgContextValue {
  const ctx = useContext(OrgContext);
  if (!ctx) throw new Error("useOrgContext must be used within OrgShell");
  return ctx;
}

/** Best-effort display name for a userId — falls back to a short id if the
 * member roster hasn't loaded yet or the user has since left the org. */
export function memberName(members: Map<string, OrgMember>, userId: string): string {
  return members.get(userId)?.name ?? `User ${userId.slice(-4)}`;
}
